


















































import { Component, Vue, Prop, PropSync, Watch } from "vue-property-decorator";
import { SortableTableHeader } from "./SortableTableDirective";

@Component
export default class GenericPMSTableSelectionBucket extends Vue {
  @PropSync("selected", { default: () => [] }) internalSelected?: any[];
  @Prop({ default: "id" }) itemKey?: string;
  @Prop({ default: () => [] }) headers?: SortableTableHeader[];
  @Prop() totalCount?: number;
  @Prop() shortDescription?: string;
  @Prop() title?: string;

  @Prop() filters?: any;
  @Prop() filterFunction?: (items: any[], filters: any) => any[];

  open = false;

  @Watch("open")
  openWatch(fresh: boolean, old: boolean) {
    if (!fresh && old) {
      this.$emit("clearSelectionFilters");
    }
  }

  get translatedHeaders() {
    if (!this.headers) {
      return [];
    }

    return [
      ...this.headers.map((x) => ({
        ...x,
        text: this.$t(x.text),
        sortable: x.sortable ?? true,
      })),
    ];
  }

  get filteredItems() {
    if (this.filterFunction && this.filters)
      return this.filterFunction(this.internalSelected ?? [], this.filters);

    return this.internalSelected ?? [];
  }

  sortBy() {
    const firstSortable = this.translatedHeaders.find((x) => x.sortable);
    return firstSortable?.value;
  }
}
